import { registerWC } from '@utils/registerWebComponent'

type FoodiCommanderProps = {
  // Required by the MFE to fetch (the offerBuilders query has no server-side
  // holding default); it renders a skeleton until this arrives.
  holdingId?: string
  // Non-`on` name: reactify-wc routes on* props to addEventListener, so this
  // callback must use a verb name to reach the MFE as a property/method.
  selectOffer: (offerId: string) => void
}

export const FoodiCommander = registerWC<FoodiCommanderProps>(
  'foodi-commander',
  '/mfe/commander',
)
